import { Canvas, type ShirtData, type Surface } from "@design-lab/features/canvas";
import { type BoundingBox } from "@design-lab/shared";
import type { BackgroundType } from "@design-lab/shared/constants";
import type { PlacementFormPosition } from "@design-lab/shared/types";
import type { InteractionMode } from "@design-lab/widgets/artboard/model/state";

import { useRefineKeyboardShortcuts } from "./hooks/useRefineKeyboardShortcuts";

type RefineCanvasWithKeyboardShortcutsProps = {
  surface: Surface;
  referenceBoundingBox: BoundingBox;
  placement: PlacementFormPosition;
  artworkImage?: HTMLImageElement | undefined;
  frontSurface?: Surface;
  backgroundType: BackgroundType;
  activeTool?: string;
  onShirtLoad: (data: ShirtData) => void;
  interactionMode: InteractionMode;
  artworkId?: string;
};

/**
 * Wrapper component that uses keyboard shortcuts hook inside RefineHistoryProvider context
 * and passes the isSpaceHeld state to Canvas
 */
export function RefineCanvasWithKeyboardShortcuts({
  surface,
  referenceBoundingBox,
  placement,
  artworkImage,
  frontSurface,
  backgroundType,
  activeTool,
  onShirtLoad,
  interactionMode,
  artworkId
}: RefineCanvasWithKeyboardShortcutsProps) {
  // Use keyboard shortcuts hook - this needs to be inside RefineHistoryProvider
  const { isSpaceHeld } = useRefineKeyboardShortcuts(artworkId);

  return (
    <Canvas
      surface={surface}
      referenceBoundingBox={referenceBoundingBox}
      placement={placement}
      readonly={false}
      artworkImage={artworkImage}
      onArtworkRemove={() => {}}
      {...(frontSurface && { frontSurface })}
      backgroundType={backgroundType}
      {...(activeTool && { activeTool })}
      onShirtLoad={onShirtLoad}
      interactionMode={interactionMode}
      isSpaceHeld={isSpaceHeld}
    />
  );
}
